import { Endpoints } from "../../../constants/endpoints";
import { TDumpoutRaw } from "./types";
import client from "../../client";

export const getDumpout = () => async () => {
  const { data } = await client.get<TDumpoutRaw>(Endpoints.getDumpout());
  return data;
};
